import { axiosInstance } from '@refinedev/simple-rest';
import { useEffect, useRef } from 'react';

type ImgProps = React.ImgHTMLAttributes<HTMLImageElement>;

export const AuthorizedImage = ({ src, ...props }: ImgProps) => {
  const ref = useRef<HTMLImageElement>(null);

  useEffect(() => {
    if (!ref.current || !src) {
      return;
    }

    const url = new URL(src, window.location.origin);

    if (
      (url.protocol === 'https:' || url.protocol === 'http:') &&
      url.origin === window.location.origin &&
      url.pathname.startsWith('/.api/')
    ) {
      axiosInstance.get(src, { responseType: 'blob' }).then((res) => {
        ref.current!.src = URL.createObjectURL(res.data);
      });
    } else {
      // e.g. `blob:`
      ref.current.src = src;
    }
  }, [src]);

  // eslint-disable-next-line jsx-a11y/alt-text
  return <img {...props} ref={ref} />;
};
